/** PRD-3334 security SOT: the backend answers a capped full-profile open with 429 VIEW_LIMIT_*. */
export const VIEW_LIMIT_CODES = ["VIEW_LIMIT_SESSION", "VIEW_LIMIT_DAILY", "VIEW_LIMIT_ACCOUNT"] as const;

export class ViewLimitError extends Error {
  readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = "ViewLimitError";
    this.code = code;
  }
}

export const isViewLimitCode = (code: unknown): code is string =>
  typeof code === "string" && (VIEW_LIMIT_CODES as readonly string[]).includes(code);
